import {acceptConsent, consentInitPromise, consentPromise, getConsentName, hasConsent} from '@utilities/sal-usercentrics/sal-usercentrics';

const embedguardLoader = {
    init: () => {
        const guardedElements = document.querySelectorAll('.embedguard');

        guardedElements.forEach((element) => {
            if (!element.dataset.guardId) {
                console.warn("Embedguard used without providing guardId attribute", element)
                return;
            }
            // If consent was already given display videos directly
            if (hasConsent(element.dataset.guardId)) {
                embedguardLoader.replaceGuard(element)
            }
            else {
                // if not wait for the consent promise and then show all videos
                consentPromise(element.dataset.guardId).then(() => {
                    embedguardLoader.replaceGuard(element);
                });
                // and display consent query on all guarded videos
                embedguardLoader.injectGuardContent(element);
            }
        })
    },

    replaceGuard: (embedguardNode) => {
        if (embedguardNode.dataset.content) {
            const tempParent = document.createElement('div');
            tempParent.innerHTML = embedguardNode.dataset.content;
            const externalContent = tempParent.firstChild;

            if (externalContent.nodeName === 'IFRAME') {
                externalContent.addEventListener('load', () => embedguardLoader.removeGuard(embedguardNode));
                embedguardNode.classList.add('embedguard--loading');
                embedguardNode.parentElement.append(externalContent);
            } else {
                embedguardNode.parentElement.append(externalContent);
                embedguardNode.remove();
            }
        }
    },

    removeGuard: (embedguardNode) => {
        embedguardNode.addEventListener('transitionend', (e) => {
            if (e.srcElement === embedguardNode) {
                embedguardNode.remove();
            }
        });
        embedguardNode.classList.add('embedguard--exit');
    },

    injectGuardContent: (embedguardNode) => {
        const contentElement = document.createElement('div');
        contentElement.classList.add('embedguard__content');

        if (embedguardNode.dataset.guardContent) {
            contentElement.innerHTML = embedguardNode.dataset.guardContent;
        }
        else {
            const headline = document.createElement('h3');
            headline.textContent = window.jsI18N.embedguard.headline;

            const intro = document.createElement('p');
            intro.classList.add('ignore-dependencies');
            let introtext = window.jsI18N.embedguard.intro;
            // intro.innerHTML = introtext;

            consentInitPromise.then(() => {
                if (introtext.includes('<strong>') && introtext.includes('</strong>')) {
                    let platform = getConsentName(embedguardNode.dataset.guardId)
                    if (platform) {
                        introtext = introtext.replace(/<strong>.*?<\/strong>/i, '<strong>' + platform + '</strong>');
                    }
                }
                intro.innerHTML = introtext;
            });

            contentElement.append(headline, intro);
        }

        const formGroup = document.createElement('div');
        formGroup.classList.add('form-group');
        formGroup.innerHTML = `
            <div class="input checkbox checkbox--switch">
                <div class="form-check">
                    <label class="add-on form-check-label">
                        <input type="checkbox">
                        <span>${window.jsI18N.embedguard.label ? window.jsI18N.embedguard.label.replace(/LINK\[(.*)]/i, '<a href="#" onClick="showConsentDetails(\'' + embedguardNode.dataset.guardId + '\')">$1</a>') : ''}</span>
                    </label>
                </div>
            </div>
        `;
        const formInput = formGroup.querySelector('input');
        formInput.addEventListener('change', () => {
            if (formInput.checked) {
                formInput.disabled = true;
                // embedguardLoader.replaceGuard(embedguardNode, true);
                acceptConsent(embedguardNode.dataset.guardId)
            }
        });

        contentElement.appendChild(formGroup);
        embedguardNode.appendChild(contentElement);
    }
};

export { embedguardLoader };
